import { msg } from '@gonfalon/messages/msg';

import { VALID_ANALYSIS_PERCENTILES } from './constants';
import type { Metric } from './types';

export function getAnalysisTypeDisplayName(analysisType: Metric['analysisType'], percentileValue?: number): string {
  if (analysisType === 'mean') {
    return msg('metrics.definitionSummary.average');
  } else if (analysisType === 'percentile' && percentileValue) {
    if (VALID_ANALYSIS_PERCENTILES.includes(percentileValue)) {
      return msg('metrics.definitionSummary.percentile', { value: percentileValue });
    }
  }
  return 'undefined';
}
